import { getNonPaginatedEndpoint } from '../utils.ts';
import { RequestParameters } from '../types';
import { ICategory } from './types.ts';

export function getCategories(params: RequestParameters): Promise<ICategory[]> {
  return getNonPaginatedEndpoint('/fields_of_activity/?page=1', params) as Promise<ICategory[]>;
}
